import React from 'react';
import { useMissionStore } from '../stores/missionStore';

const SCORE_TYPES = ['Assault', 'Deception', 'Stealth', 'Social', 'Transport'];

export const ScoreTypeSelector: React.FC = (): JSX.Element => {
  const { selectedScoreType, setScoreType } = useMissionStore();

  const containerStyle: React.CSSProperties = {
    marginBottom: '32px',
  };

  const labelStyle: React.CSSProperties = {
    display: 'block',
    color: '#d4af37',
    fontWeight: 600,
    fontSize: '14px',
    marginBottom: '12px',
    textTransform: 'uppercase' as const,
    letterSpacing: '0.05em',
  };

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(120px, 1fr))',
    gap: '12px',
  };

  const getButtonStyle = (isSelected: boolean): React.CSSProperties => ({
    padding: '12px 16px',
    borderRadius: '8px',
    border: isSelected ? '2px solid #d4af37' : '1px solid rgba(212, 175, 55, 0.2)',
    backgroundColor: isSelected ? '#d4af37' : '#0f0f1e',
    color: isSelected ? '#0f0f1e' : '#9ca3af',
    fontWeight: isSelected ? 600 : 500,
    fontSize: '14px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    textAlign: 'center' as const,
  });

  const clearButtonStyle: React.CSSProperties = {
    marginTop: '12px',
    padding: '8px 16px',
    backgroundColor: 'transparent',
    border: '1px solid rgba(212, 175, 55, 0.2)',
    borderRadius: '6px',
    color: '#6b7280',
    fontSize: '13px',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
  };

  return (
    <div style={containerStyle}>
      <label style={labelStyle}>Score Type (Optional)</label>
      <div style={gridStyle}>
        {SCORE_TYPES.map(type => {
          const isSelected = selectedScoreType === type;
          return (
            <button
              key={type}
              onClick={() => setScoreType(type === selectedScoreType ? null : type)}
              style={getButtonStyle(isSelected)}
              onMouseEnter={e => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.5)';
                  e.currentTarget.style.color = '#d4af37';
                  e.currentTarget.style.backgroundColor = 'rgba(212, 175, 55, 0.05)';
                }
              }}
              onMouseLeave={e => {
                if (!isSelected) {
                  e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
                  e.currentTarget.style.color = '#9ca3af';
                  e.currentTarget.style.backgroundColor = '#0f0f1e';
                }
              }}
            >
              {type}
            </button>
          );
        })}
      </div>
      {selectedScoreType && (
        <button
          onClick={() => setScoreType(null)}
          style={clearButtonStyle}
          onMouseEnter={e => {
            e.currentTarget.style.borderColor = '#d4af37';
            e.currentTarget.style.color = '#d4af37';
          }}
          onMouseLeave={e => {
            e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.2)';
            e.currentTarget.style.color = '#6b7280';
          }}
        >
          Clear selection
        </button>
      )}
    </div>
  );
};
